import { render, staticRenderFns } from "./register-detail.vue?vue&type=template&id=1ed482ac"
import script from "./register-detail.vue?vue&type=script&lang=js"
export * from "./register-detail.vue?vue&type=script&lang=js"
import style0 from "./register-detail.vue?vue&type=style&index=0&id=1ed482ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports